<div class="modal-header">
  <h4 class="modal-title">Confirmación</h4>
</div>
<div class="modal-body">
  ¿Esta seguro que deseas registrar asistencia como: {{ nombreUsuario }}?
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="confirm()">Confirmar</button>
  <button class="btn btn-danger" (click)="close()">Cerrar sesión</button>
</div>
